<template>
  <div class="object-detail-item">
    <div class="right-header" @click="getDetailInfoRight()">
      <!-- <button @click="qwe()">qwe</button> -->
      <div class="right-header-info">
        <div class="right-header-items">
          <h5>{{ item.rightType.text }}</h5>
          <template v-if="item.rightOwnerSet.edges.length >= 2">
            <h5>{{ 'Несколько правообладателей' }}</h5>
          </template>
          <template v-else>
            <h5 class="cursive-text">{{ item.rightOwnerSet.edges[0].node.owner.sp.text }}</h5>
            <h5>{{ item.rightOwnerSet.edges[0].node.owner.name }}</h5>
          </template>
        </div>
        <div class="right-header-wrap">
          <img v-if="isRent" src="@img/rent.svg" alt="В аренде" title="В аренде">
          <span>№ {{ rightIndex + 1 }}</span>
        </div>
      </div>
      <button class="more" :class="{'active': showRight}">
        <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M6 5.60876L10.4834 0.75L12 2.24761L6 8.75L-6.54624e-08 2.24761L1.51664 0.75L6 5.60876Z" fill="black" fill-opacity="0.65"/>
        </svg>
      </button>
    </div>
    <div class="right-block-wrapper" v-if="showRight">
      <div class="right-block">
        <div class="right-block-item" v-if="rightInfo.rightType !== null && rightInfo.rightType !== undefined">
          <h6>Вид права</h6>
          <p>{{ rightInfo.rightType.text}}</p>
        </div>
        <div class="right-block-item" v-if="rightInfo.regNumber !== null && rightInfo.regNumber !== undefined">
          <h6>Регистрационный номер</h6>
          <p>{{ rightInfo.regNumber}}</p>
        </div>
        <div class="right-block-item" v-if="rightInfo.regDate !== null && rightInfo.regDate !== undefined">
          <h6>Дата регистрации</h6>
          <p>{{ rightInfo.regDate}}</p>
        </div>
        <div class="share-block">
          <div class="right-block-item" v-if="rightInfo.shareNumerator !== null && rightInfo.shareNumerator !== undefined">
            <h6>Доля в праве (числ)</h6>
            <p>{{ rightInfo.shareNumerator}}</p>
          </div>
          <div class="right-block-item" v-if="rightInfo.shareDenominator !== null && rightInfo.shareDenominator !== undefined">
            <h6>Доля в праве (знам)</h6>
            <p>{{ rightInfo.shareDenominator}}</p>
          </div>
        </div>
        <div class="right-block-item" v-if="rightInfo.note !== null && rightInfo.note !== undefined">
          <h6>Примечание</h6>
          <p>{{ rightInfo.note}}</p>
        </div>
        <template v-if="rightInfo.rightOwnerSet !== null && rightInfo.rightOwnerSet !== undefined">
          <div class="toggle-block-item" v-for="(owner, index) in rightInfo.rightOwnerSet.edges" :key="'own_' + index">
            <ToggleComponentVue>
              <template #title>
                <h5>Правообладатель {{ index + 1}}</h5>
              </template>
              <template #content>
                <div class="owner-block-item" v-if="owner.node.owner.sp !== null && owner.node.owner.sp !== undefined">
                  <h6>Вид правообладателя</h6>
                  <p>{{ owner.node.owner.sp.text}}</p>
                </div>
                <div class="type-owner-detail" v-if="owner.node.owner.sp !== null && owner.node.owner.sp !== undefined">
                  <!-- <div class="organization" v-if="isOrganizationMix(owner.node.owner.sp.code) && owner.node.owner.organizationSet !== null">
                    <div class="organization-block" v-for="(org, index) in owner.node.owner.organizationSet.edges" :key="'org_' + index"> -->
                  <div class="organization" v-if="isOrganizationMix(owner.node.owner.sp.code) && owner.node.owner.organization !== null">
                    <div class="organization-block">
                      <ToggleComponentVue>
                        <template #title>
                          <h5>Организация</h5>
                        </template>
                        <template #content>
                          <div class="owner-block-item" v-if="owner.node.owner.organization.name !== null && owner.node.owner.organization.name !== undefined">
                            <h6>Наименование</h6>
                            <p>{{ owner.node.owner.organization.name }}</p>
                          </div>
                          <div class="owner-block-item" v-if="owner.node.owner.organization.fullName !== null && owner.node.owner.organization.fullName !== undefined">
                            <h6>Полное наименование</h6>
                            <p>{{ owner.node.owner.organization.fullName }}</p>
                          </div>
                          <div class="owner-block-item" v-if="owner.node.owner.oid !== null && owner.node.owner.oid !== undefined">
                            <h6>ИНН/СНИЛС</h6>
                            <p>{{ owner.node.owner.oid }}</p>
                          </div>
                          <div class="owner-block-item" v-if="owner.node.owner.organization.ogrn !== null && owner.node.owner.organization.ogrn !== undefined">
                            <h6>ОГРН</h6>
                            <p>{{ owner.node.owner.organization.ogrn }}</p>
                          </div>
                          <!-- <div class="owner-block-item" v-if="owner.node.owner.organization.phone !== ''">
                            <h6>Номер телефона</h6>
                            <p>{{ owner.node.owner.organization.phone }}</p>
                          </div> -->
                        </template>
                      </ToggleComponentVue>
                    </div>
                  </div>
                  <div class="person" v-else-if="isPersonMix(owner.node.owner.sp.code)">
                    <div class="person-block">
                      <ToggleComponentVue>
                        <template #title>
                          <h5>Персона {{ index + 1}}</h5>
                        </template>
                        <template #content>
                          <div class="owner-block-item">
                            <h6>Фамилия</h6>
                            <p>{{ owner.node.owner.person.lastName }}</p>
                          </div>
                          <div class="owner-block-item">
                            <h6>Имя</h6>
                            <p>{{ owner.node.owner.person.firstName }}</p>
                          </div>
                          <div class="owner-block-item">
                            <h6>Отчество</h6>
                            <p>{{ owner.node.owner.person.middleName }}</p>
                          </div>
                          <div class="owner-block-item" v-if="owner.node.owner.oid !== null && owner.node.owner.oid !== undefined">
                            <h6>ИНН/СНИЛС</h6>
                            <p>{{ owner.node.owner.oid }}</p>
                          </div>
                          <!-- <div class="owner-block-item" v-if="owner.node.owner.person.phone !== null">
                            <h6>Номер телефона</h6>
                            <p>{{ owner.node.owner.person.phone }}</p>
                          </div> -->
                        </template>
                      </ToggleComponentVue>
                    </div>
                  </div>
                  <div class="governance" v-else>
                    <div class="governance-block">
                      <ToggleComponentVue>
                        <template #title>
                          <h5>Управление {{ index + 1}}</h5>
                        </template>
                        <template #content>
                          <div class="owner-block-item">
                            <h6>Наименование</h6>
                            <p>{{ owner.node.owner.governance.name }}</p>
                          </div>
                        </template>
                      </ToggleComponentVue>
                    </div>
                  </div>
                </div>
              </template>
            </ToggleComponentVue>
          </div>
        </template>
        <template v-if="rightInfo.documentSet !== null && rightInfo.documentSet !== undefined">
          <div class="toggle-block-item" v-for="(doc, index) in rightInfo.documentSet.edges" :key="'doc_' + index">
            <ToggleComponentVue>
              <template #title>
                <h5>Документ {{ index + 1}}</h5>
              </template>
              <template #content>
                <div class="document-block">
                  <div class="document-block-item" v-if="doc.node.documentType !== null && doc.node.documentType !== undefined">
                    <h6>Тип документа</h6>
                    <p>{{ doc.node.documentType.text}}</p>
                  </div>
                  <div class="document-block-item" v-if="doc.node.seria">
                    <h6>Серия</h6>
                    <p>{{ doc.node.seria}}</p>
                  </div>
                  <div class="document-block-item" v-if="doc.node.number">
                    <h6>Номер</h6>
                    <p>{{ doc.node.number}}</p>
                  </div>
                  <div class="document-block-item" v-if="doc.node.date">
                    <h6>Дата</h6>
                    <p>{{ doc.node.date}}</p>
                  </div>
                  <div class="document-block-item" v-if="doc.node.notes">
                    <h6>Примечание</h6>
                    <p>{{ doc.node.notes}}</p>
                  </div>
                  <div class="document-block-item">
                    <h6>Файл</h6>
                    <a class="doc-link" :href="getDownloadDocUrl(doc.node.file)">
                      <div class="doc-info">
                        <span class="doc-title">{{ doc.node.file }}</span>
                      </div>
                      <button>
                        <img src="@img/download.svg" alt="">
                      </button>
                    </a>
                  </div>
                </div>
              </template>
            </ToggleComponentVue>
          </div>
        </template>
        <template v-if="item.encumbranceSet.edges.length > 0">
          <div class="right-block-item encumbrance-item" v-for="(enc, index) in item.encumbranceSet.edges" :key="'e_' + index" @click="showEncumbranceDetail(index)">
            <h6>Обременение {{ index + 1}}</h6>
            <img src="@img/enc-open.svg" alt="" :class="{'active': encumbranceDetail[index] === 'true'}">
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import ToggleComponentVue from './ToggleComponentVue'
import { eventBus } from '@/main.js'

const GET_DETAIL_RIGHT_SINGLE = gql`
query GET_DETAIL_RIGHT_SINGLE($idR: ID!) {
  right(id: $idR) {
    id
    rightType {
      text
      code
    }
    regNumber
    regDate
    shareNumerator
    shareDenominator
    note
    rightOwnerSet {
      edges {
        node {
          owner {
            sp {
              code
              text
            }
            typeOfOwner {
              text
            }
            oid
            governance {
              name
            }
            person {
              firstName
              lastName
              middleName
              phone
              address {
                oai
                text
                okato
                note
              }
            }
            # organizationSet {
            #   edges {
            #     node {
            #       name
            #       fullName
            #       ogrn
            #       phone
            #     }
            #   }
            # }
            organization {
              name
              fullName
              ogrn
              phone
            }
          }
        }
      }
    }
    documentSet {
      edges {
        node {
          documentType {
            text
            code
          }
          seria
          number
          date
          notes
          file
        }
      }
    }
    encumbranceSet {
      edges {
        node {
          encumbranceType {
            text
          }
        }
      }
    }
  }
}
`

const GET_ENCUMBRANCE_SINGLE = gql`
query GET_ENCUMBRANCE_SINGLE($idE: ID!) {
  encumbrance (id: $idE) {
    encumbranceType {
      text
      code
    }
    name
    regNumber
    regDate
    dateStarted
    dateStopped
    notes
    documentSet {
      edges {
        node {
          documentType {
            text
            code
          }
          seria
          number
          date
          notes
          file
        }
      }
    }
    encumbranceOwnerSet {
      edges {
        node {
          owner {
            sp {
              text
              code
            }
            name
            typeOfOwner {
              text
            }
            oid
            governance {
              name
            }
            person {
              firstName
              lastName
              middleName
              phone
              address {
                oai
                text
                okato
                note
              }
            }
            # organizationSet {
            #   edges {
            #     node {
            #       name
            #       fullName
            #       ogrn
            #       phone
            #     }
            #   }
            # }
            organization {
              name
              fullName
              ogrn
              phone
            }
          }
        }
      }
    }
  }
}
`

export default {
  props: ['item', 'rightIndex', 'pk'],
  components: {
    ToggleComponentVue
  },
  data () {
    return {
      showRight: false,
      rightInfo: {},
      idR: null,
      idE: null,
      encumbranceDetailInfo: {},
      tinySliderOptions: {
        mouseDrag: true,
        loop: false,
        nav: false,
        gutter: 8,
        items: 1,
        fixedWidth: '160px',
        controlsText: ['', '']
      }
    }
  },
  computed: {
    encumbranceDetail () {
      return this.$store.getters.value('encumbranceDetail')
    },
    isRent () {
      let rent = this.item.encumbranceSet.edges.find(encum => {
        if (encum.node.encumbranceType !== null) {
          return encum.node.encumbranceType.code === '22006000000'
        }
      })
      return rent !== undefined
    }
  },
  methods: {
    getDetailInfoRight () {
      if (this.showRight === true) {
        this.showRight = false
      } else {
        this.showRight = true
        this.$apollo.query({
          query: GET_DETAIL_RIGHT_SINGLE,
          variables: {
            idR: this.item.id
          }
        }).then(response => {
          this.rightInfo = response.data.right
        })
      }
    },
    getDownloadDocUrl (key) {
      if (key === null) {
        return 'javascript:void(0)'
      }
      return this.getMinioFileUrlMix('document', key)
    },
    showEncumbranceDetail (index) {
      if (this.encumbranceDetail[index] === 'true') {
        this.$store.dispatch('SET_VALUE', {key: 'encumbranceDetail', value: []})
        this.item.encumbranceSet.edges.forEach(encum => {
          encum = 'false'
        })
      } else {
        this.$apollo.query({
          query: GET_ENCUMBRANCE_SINGLE,
          variables: {
            idE: this.item.encumbranceSet.edges[index].node.id
          }
        }).then(response => {
          this.encumbranceDetailInfo = response.data.encumbrance
          eventBus.$emit('encFull', this.encumbranceDetailInfo)
        })
        this.$store.dispatch('SET_VALUE_WITH_INDEX', {key: 'encumbranceDetail', value: 'true', ind: index})
        this.$store.dispatch('SET_VALUE', {key: 'rightIndex', value: this.rightIndex})
        this.$store.dispatch('SET_VALUE', {key: 'encIndex', value: index})
      }
    },
    qwe () {
      console.log(this.item)
    }
  },
  mounted () {
    this.item.encumbranceSet.edges.forEach(encum => {
      this.encumbranceDetail.push('false')
    })
    // 36:11:4400015:293
  }
}
</script>

<style lang="scss" scoped>
.object-detail-item:last-child {
  margin-bottom: 0;
}
.right {
  &-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    button {
      transition: .3s;
      &.active {
        transform: rotate(180deg);
      }
    }
    &-info {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
    }
    &-items {
      width: 70%;
      h5 {
        margin: 10px 0;
        &:first-child {
          margin-top: 0;
        }
        &:last-child {
          margin-bottom: 0;
        }
      }
      .cursive-text {
        font-style: italic;
      }
    }
    &-wrap {
      margin-right: 10px;
      img,
      span {
        vertical-align: middle;
      }
    }
  }
  &-block {
    margin-top: 15px;
    &-item {
      margin-bottom: 20px;
      &:last-child {
        margin-bottom: 0;
      }
      h6 {
        vertical-align: middle;
        font-size: 12px;
        font-weight: 400;
        color: #8c8c8c;
        margin-bottom: 5px;
      }
      p {
        font-size: 12px;
      }
      .document-block-item {
        h6 {
          margin-bottom: 0;
        }
        margin-bottom: 10px;
      }
    }
    .encumbrance-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      cursor: pointer;
      margin-bottom: 0;
      border-radius: 8px;
      padding: 10px 15px;
      transition: .3s;
      &:hover {
        background-color: #f2f2f2;
      }
      img {
        transition: .3s;
        &.active {
          transform: rotate(180deg);
        }
      }
      h6 {
        font-weight: 600;
        font-size: 14px;
        color: #242424;
        margin-bottom: 0;
      }
    }
  }
}

.document {
  &-block {
    display: table;
    width: 100%;
    margin-top: 15px;
    &-item {
      display: table-row;
      &:last-child {
        h6,
        p {
          padding-bottom: 0;
        }
      }
      h6,
      p {
        display: table-cell;
        padding-bottom: 10px;
        font-size: 12px;
      }
      h6 {
        vertical-align: middle;
        width: 105px;
        font-size: 12px;
        padding-right: 10px;
        text-align: right;
        font-weight: 400;
        color: #929292;
      }
    }
  }
}
.share-block {
  display: flex;
  .right-block-item {
    margin-right: 15px;
  }
}
.owner {
  &-block {
    &-item {
      h6 {
        font-size: 12px;
        margin-bottom: 5px;
      }
      p {
        font-size: 12px;
      }
    }
  }
}
.info-wrapper {
  margin-top: 15px;
}

.doc-link {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #000;
  .doc-title {
    display: inline-block;
    width: 215px;
    font-size: 12px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  button {
    flex: none;
  }
}
.toggle-block-item {
  padding-bottom: 15px;
  margin-bottom: 15px;
  border-bottom: 1px solid #e6e6e6;
  &:last-child {
    margin-bottom: 0;
    border: none;
    padding-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/RightVue.vue